export const goldloanCalculatorData = [
  {
    id: 1,
    heading: "Gold Loan EMI Calculator: Simplify Your Repayment Planning",
    subHeading:
      "Calculate your monthly EMIs effortlessly and plan your gold loan repayments with precision. Use our Gold Loan EMI Calculator for accurate and instant results.",
    headingTwo: "Estimate your monthly payment and more",
    notice:
      "Many, or all, of the products featured on this page are from our advertising partners who compensate us when you take certain actions on our website or click to take an action on their website. However, this does not influence our evaluations. Our opinions are our own. Here is a list of our partners and here's how we make money.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
